/**
 * Configura as propriedades de exibição do Editor.
 */
export const options = {
  autoIndent: true,
  automaticLayout: true,
  cursorBlinking: 'blink',
  wordWrap: 'on',
  wrappingIndent: 'same',
  scrollBeyondLastLine: false,
  minimap: {
    enabled: true,
  },
};

/**
 * Busca pelo par de fechamento do caractere informado.
 * @param {string} text Bloco de texto.
 * @param {int} openPos Posição da caractere de abertura.
 * @param {string} bracket Par de fechamento a ser encontrado.
 */
export const findClosingPair = (text, openPos, bracket) => {
  const brackets = [
    { open: '{', close: '}' },
    { open: '[', close: ']' },
    { open: '(', close: ')' },
  ];
  const bracketPair = brackets.find((b) => b.open === bracket || b.close === bracket);

  let openCount = 0;
  for (let i = openPos; i < text.length; i++) {
    if (text[i] === bracketPair.open) openCount++;
    else if (text[i] === bracketPair.close) {
      openCount--;
      if (openCount === 0) return i;
    }
  }
  return -1;
};

/**
 * Busca o nível de espaçamento a ser aplicado através da contagem de chaves abertas e fechadas até a chave de fechamento sendo avaliada.
 * @param {string} text Bloco de texto
 */
export const findBracketLevel = (text) => {
  const openingBrackets = (text.match(/{/g) || []).length;
  const closingBrackets = (text.match(/}/g) || []).length;
  return closingBrackets - openingBrackets;
};

/**
 * Busca pela linha e coluna a partir de um texto com quebras de linha.
 * @param {string} text Bloco de texto
 * @param {int} start Posição inicial
 * @param {int} end Posição final
 */
export const findLineColumn = (text, start, end) => {
  const textList = text.split('\n');
  for (let i = 0; i <= textList.length; i++) {
    const lineLength = textList[i].length + 1;

    if (lineLength > start) {
      return { linha: i + 1, coluna: start, colunaFim: end };
    }
    start -= lineLength;
    end -= lineLength;
  }
  return null;
};

export const getWordByPosition = (str, pos) => {
  let leftSideString = str.substr(0, pos);
  let rightSideString = str.substr(pos);

  let leftMatch = leftSideString.match(/[^.,\s]*$/);
  let rightMatch = rightSideString.match(/^[^.,\s]*/);

  let resultStr = '';

  if (leftMatch) {
    resultStr += leftMatch[0];
  }

  if (rightMatch) {
    resultStr += rightMatch[0];
  }

  return {
    index: leftMatch.index,
    word: resultStr,
  };
};
